<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="organDonorOptions"
        :db="db"
        :args="args"
        :skipped="skipped"
        class="radio-options-wide"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import {willRelationshipHelpers} from "../../../../fieldsets/will/helpers/willRelationshipHelpers";
import {willPeopleHelpers} from "../../../../fieldsets/will/helpers/willPeopleHelpers";
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {willOptions} from "../../../options/willOptions";
import {personHelpers} from "@/mixins/personHelpers";
import {textHelpers} from "@/mixins/textHelpers";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";


export default {
  name: 'DonorType',
  mixins: [questionLoadHelpers, willPeopleHelpers, willRelationshipHelpers, personHelpers, textHelpers, willOptions],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [String, Boolean],
      required: false
    },
    details: {
      type: Object,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'Would you like to be an organ donor?',
        subTitle: 'By default your organs can be used for therapy, if you would prefer to opt out this should be done online, although documenting preferences in your Will is also useful.',
        tip: null,
      },
      db: {
        saveLocation: 'product_will_data',
        saveField: 'donorType',
        formPath: 'data.funeral.details.donorOption',
        jsonSaveField: 'donorOption'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
